import styled from 'styled-components'

import secondary from '../../styles/mixins/secondary'
import hint from '../../styles/mixins/hint'

export default styled.div`
  ${secondary}
  ${hint}
`
